import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createFact,updateFact, deleteFact, getEcoActivities, getEcoActivityById, getFactById, getFacts, updateEcoActivity, deleteEcoActivity, getEcoActivityCommentsById, deleteEcoActivityComment } from '../api/facts';

export const useCreateFact = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['createFact'],
        mutationFn: (data) => createFact(data),
        onSuccess: () => {
            queryClient.invalidateQueries(['facts']);
        },
    });
}

export const useUpdateFact = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['updateFact'],
        mutationFn: (data) => updateFact(data),
        onSuccess: () => {
            queryClient.invalidateQueries(['facts']);
        },
    });
}

export const useGetFacts = () => {
    return useQuery({
        queryKey: ['facts'],
        queryFn: () => getFacts(),
        refetchOnWindowFocus: false,
    });
}

export const useDeleteFact = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['deleteFact'],
        mutationFn: (id) => deleteFact(id),
        onSuccess: () => {
            queryClient.invalidateQueries(['facts']);
        },
    });
}

export const useGetFactDetails = (id) => {
    return useQuery({
        queryKey: ['factDetails', id],
        queryFn: () => getFactById(id),
        enabled: !!id, // Only run the query if id is defined
    });
}

export const useEcoActivityList = () => {
    return useQuery({
        queryKey: ['ecoActivities'],
        queryFn: () => getEcoActivities(),
        refetchOnWindowFocus: false,
        retry: 0,
    });
}

export const useDeleteEcoActivity = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['deleteEcoActivity'],
        mutationFn: (id) => deleteEcoActivity(id),
        onSuccess: () => {
            queryClient.invalidateQueries(['ecoActivities']);
        },
    });
}

export const useGetEcoActivityDetails = (id) => {
    return useQuery({
        queryKey: ['ecoActivityDetails', id],
        queryFn: () => getEcoActivityById(id),
        enabled: !!id, // Only run the query if id is defined
    });
}

// export const useGetEcoActivityLikes = () => {
//     return useQuery({
//         queryKey: ['ecoActivityLikes'],
//         queryFn: () => getEcoActivityLikesById(),
//         refetchOnWindowFocus: false,
//         retry: 0,
//     });
// }

export const useGetEcoActivityUserComments = (data) => {
    return useQuery({
        queryKey: ['ecoActivityComments', data],
        queryFn: () => getEcoActivityCommentsById(data),
        enabled: !!data,
        retry: 1,
    });
}

export const useUpdateEcoActivity = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['updateEcoActivity'],
        mutationFn: (data) => updateEcoActivity(data),
        onSuccess: (response, variables) => {
            // Invalidate eco activities list and the specific detail cache so UI stays in sync
            queryClient.invalidateQueries(['ecoActivities']);
            if (variables && variables.id) {
                queryClient.invalidateQueries(['ecoActivityDetails', variables.id]);
                queryClient.invalidateQueries(['ecoActivityComments', variables.id]);
            }
        },
    });
}

export const useDeleteEcoActivityComment = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['deleteEcoActivityComment'],
        mutationFn: (data) => deleteEcoActivityComment(data),
        onSuccess: () => {
            queryClient.invalidateQueries(['ecoActivities', 'ecoActivityComments']);
        },
    });
}